import list from './list'
import show from './show'
import edit from './edit'
import create from './create'
import icon from '@mui/icons-material/ThumbDownAlt'

const adminConfig = { list, create, edit, show, icon };

export default adminConfig;
